import ApiWrapper from './ApiWrapper';

class BannerAPI extends ApiWrapper{
  constructor() {
    super('https://sigawebservices.praxio.com.br/banner');
  }

  getBanner(cnpj: string){
    return this.fetch({
      endpoint: `banner/siga_emissor/${cnpj}`,
      method: 'GET',
      headers: {
        'x-api-key': 'chaveSuperSecretaConfia-123-cecidilha',
      }
    });
  }
};

const bannerAPI = new BannerAPI();
export default bannerAPI;